import { configDeviceList } from './devicesList';


const LEGACY_BREAKPOINT_MAP = {
    1180: 1280,
    992: 1024,
    480: 640,
};


const LEGACY_DEVICE_ID_MAP = {
    desktop: 'default',
    tablethorizontal: 'xl',
    tablet: 'lg',
    mobileportrait: 'sm',
};

const normalizeDeviceKey = (value) =>
    String(value || '')
        .toLowerCase()
        .replace(/\s+/g, '');

const migrateBreakpointInText = (text) => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    let result = text;
    Object.entries(LEGACY_BREAKPOINT_MAP).forEach(([oldPx, newPx]) => {
        const pattern = new RegExp(`max-width\\s*:\\s*${oldPx}px`, 'gi');
        result = result.replace(pattern, `max-width: ${newPx}px`);
    });

    return result;
};

const migrateStyleEntry = (style) => {
    if (!style || typeof style !== 'object') {
        return style;
    }

    const migrated = { ...style };

    if (migrated.mediaText) {
        migrated.mediaText = migrateBreakpointInText(migrated.mediaText);
    }
    if (migrated.atRuleParams) {
        migrated.atRuleParams = migrateBreakpointInText(migrated.atRuleParams);
    }
    if (migrated.atRule) {
        migrated.atRule = migrateBreakpointInText(migrated.atRule);
    }

    return migrated;
};

export const resolveDeviceId = (deviceRef) => {
    const normalized = normalizeDeviceKey(deviceRef);
    const fromConfig = configDeviceList.devices.find(
        (device) =>
            normalizeDeviceKey(device.id) === normalized ||
            normalizeDeviceKey(device.name) === normalized
    );

    if (fromConfig) {
        return fromConfig.id;
    }

    return LEGACY_DEVICE_ID_MAP[normalized] || configDeviceList.default;
};

export const getDeviceById = (deviceId) =>
    configDeviceList.devices.find((device) => device.id === deviceId);

export const migrateLegacyBreakpointsInProject = (project) => {
    if (!project || typeof project !== 'object') {
        return project;
    }

    const migrated = { ...project };

    if (Array.isArray(migrated.styles)) {
        migrated.styles = migrated.styles.map(migrateStyleEntry);
    }

    if (migrated.device) {
        migrated.device = resolveDeviceId(migrated.device);
    }

    return migrated;
};
